import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CalendarCheck, ArrowRight } from "lucide-react";

export const SundayCheckinCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/checkin/summary").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;

  const { summary, existing } = data;
  const due = summary.is_checkin_window && !existing;
  const kept = `${summary.commitments_kept}/${summary.commitments_possible}`;

  return (
    <Link
      to="/checkin"
      className={`card card-interactive flex items-center justify-between gap-4 mb-8 ${due ? "pulse-brand" : ""}`}
      style={due ? { borderColor: "#FF0055" } : {}}
      data-testid="sunday-checkin-card"
    >
      <div className="flex items-center gap-4">
        <div className="w-11 h-11 flex items-center justify-center shrink-0" style={{ background: due ? "#FF0055" : "#1A1A1A", border: `1px solid ${due ? "#FF0055" : "#3f3f46"}` }}>
          <CalendarCheck size={20} color={due ? "white" : "#a1a1aa"} />
        </div>
        <div>
          <p className="eyebrow" style={due ? { color: "#FF0055" } : {}}>
            {existing ? "Check-in locked in" : due ? "It's time" : "Sunday check-in"}
          </p>
          <p className="font-display font-bold text-base md:text-lg mt-1 uppercase">
            {existing ? `I proved I can ${existing.proved}` : due ? "CINDR // Sunday Check-in" : summary.commitments_possible ? `${kept} commitments kept so far` : "Tell the truth and use it"}
          </p>
          {!existing && !due && <p className="text-xs text-zinc-500 mt-1">Your weekly review opens Sunday. Tell the truth and use it.</p>}
        </div>
      </div>
      <ArrowRight size={18} color={due ? "#FF0055" : "#71717a"} />
    </Link>
  );
};
